import { render, staticRenderFns } from "./ComSideMenu.vue?vue&type=template&id=2e6ed68a&scoped=true&"
import script from "./ComSideMenu.vue?vue&type=script&lang=js&"
export * from "./ComSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ComSideMenu.vue?vue&type=style&index=0&id=2e6ed68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ed68a",
  null
  
)

export default component.exports